export const Divider = () => <div className="divider px-4" />;

export default Divider;
